import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_ds_get_inventory_adjustment_tasksService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { owner?: string, project?: string, material?: string, packaging?: string, vendor_lot?: string, lot?: string, warehouse?: string, location?: string, completed_from?: string, completed_to?: string, not_transmitted?: boolean }): 
  Promise<{ result: { Id?: number, ActualInventoryAmount?: number, ActualPackagedAmount?: number, CompletedDateTime?: string, ActualPackagedPack?: { Name?: string }, Material?: { LookupCode?: string }, Lot?: { LookupCode?: string, TypeId?: number, VendorLot?: { LookupCode?: string } }, ActualSourceLicensePlate?: { LookupCode?: string }, ActualSourceLocation?: { Name?: string }, ActualTargetLocation?: { Name?: string }, Warehouse?: { Name?: string }, Project?: { LookupCode?: string, Owner?: { LookupCode?: string } } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { owner?: string, project?: string, material?: string, packaging?: string, vendor_lot?: string, lot?: string, warehouse?: string, location?: string, completed_from?: string, completed_to?: string, not_transmitted?: boolean, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualInventoryAmount?: number, ActualPackagedAmount?: number, CompletedDateTime?: string, ActualPackagedPack?: { Name?: string }, Material?: { LookupCode?: string }, Lot?: { LookupCode?: string, TypeId?: number, VendorLot?: { LookupCode?: string } }, ActualSourceLicensePlate?: { LookupCode?: string }, ActualSourceLocation?: { Name?: string }, ActualTargetLocation?: { Name?: string }, Warehouse?: { Name?: string }, Project?: { LookupCode?: string, Owner?: { LookupCode?: string } } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { owner?: string, project?: string, material?: string, packaging?: string, vendor_lot?: string, lot?: string, warehouse?: string, location?: string, completed_from?: string, completed_to?: string, not_transmitted?: boolean, $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualInventoryAmount?: number, ActualPackagedAmount?: number, CompletedDateTime?: string, ActualPackagedPack?: { Name?: string }, Material?: { LookupCode?: string }, Lot?: { LookupCode?: string, TypeId?: number, VendorLot?: { LookupCode?: string } }, ActualSourceLicensePlate?: { LookupCode?: string }, ActualSourceLocation?: { Name?: string }, ActualTargetLocation?: { Name?: string }, Warehouse?: { Name?: string }, Project?: { LookupCode?: string, Owner?: { LookupCode?: string } } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      owner?: string, project?: string, material?: string, packaging?: string, vendor_lot?: string, lot?: string, warehouse?: string, location?: string, completed_from?: string, completed_to?: string, not_transmitted?: boolean    }) {
      return false;
    }
}
